import React from 'react';
import { CheckIcon, AlertTriangleIcon } from 'lucide-react';
export function PricingSection() {
  return <section className="mb-16" id="pricing" data-id="element-103">
      <h2 className="text-2xl font-bold mb-6 text-blue-900" data-id="element-104">
        Special Internet-Only Offer
      </h2>
      <p className="text-lg mb-6" data-id="element-105">
        Right now, Petssey is offering bundle savings:
      </p>
       <div className="text-center" data-id="element-106">
        <a href="https://petssey.com/products/petssey-dnrx" className="inline-flex items-center justify-center px-8 py-4 text-xl font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 transition-colors mb-2" data-id="element-107">
          Claim My Discount & Check Availability
        </a>
        <p className="text-lg text-red-600" data-id="element-108">
          Don't wait. Once stock runs out, you may end up on a waitlist.
        </p>
      </div>
      <div className="bg-blue-50 p-6 rounded-lg mb-8" data-id="element-109">
        <h3 className="text-xl font-bold mb-4 text-blue-900" data-id="element-110">
          Our 45-Day Breathe Easier Promise
        </h3>
        <p className="text-lg mb-4" data-id="element-111">
          Try Petssey DNRx for 45 days in your home. If you don't notice fresher
          air, fewer reactions, and less "cat smell" — return it for a full
          refund.
        </p>
        <p className="text-lg font-medium" data-id="element-112">
          No questions asked. No hidden fees.
        </p>
      </div>
     
    </section>;
}